import { render, staticRenderFns } from "./CsrPolicy.vue?vue&type=template&id=f13533d0&scoped=true&"
import script from "./CsrPolicy.vue?vue&type=script&lang=js&"
export * from "./CsrPolicy.vue?vue&type=script&lang=js&"
import style0 from "./CsrPolicy.vue?vue&type=style&index=0&id=f13533d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13533d0",
  null
  
)

export default component.exports